import { Map, Record } from "immutable";

import {
  CrudBuilderState,
  makeCrudBuilderInitialState
} from "seneca-common/utils/apiStates/crudBuilder/models/CrudBuilderState";

import {
  classAllAssignmentsFetchStateConfig,
  classCurrentAssignmentsFetchStateConfig,
  individualAssignmentsStateConfig
} from "../consts";

export type TeacherAssigmentsStateType = {
  individualAssignments: CrudBuilderState | Map<any, any>;
  pastAssignments: CrudBuilderState | Map<any, any>;
  futureAssignments: CrudBuilderState | Map<any, any>;
};

const defaultTeacherAssignmentsStateType: TeacherAssigmentsStateType = {
  individualAssignments: makeCrudBuilderInitialState(
    individualAssignmentsStateConfig
  ),
  pastAssignments: makeCrudBuilderInitialState(
    classAllAssignmentsFetchStateConfig
  ),
  futureAssignments: makeCrudBuilderInitialState(
    classCurrentAssignmentsFetchStateConfig
  )
};

export default class TeacherAssignmentsState extends Record(
  defaultTeacherAssignmentsStateType
) {}
